import React from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useSelector } from 'react-redux'
import DeleteIcon from '../../../commonComponents/deleteIcon'
import CopyRepElement from './copyRepElement'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'


const AdditionalProcedureForm = ({ isFormDisabled=false,saveItem,deleteItem,updateItem,copyData,item:{id,requestedProcedureCode} }) =>{
  const additionalProcedureList = useSelector((state) => state.DropDownValues.additionalProcedure)
  const {isDisabled} = useCurrentShipmentType() 

  return (
    <Grid.Row>
      <Grid.Column width={1} style={{textAlign:'center'}}>
        <CopyRepElement
          title={`ADDITIONAL PROCEDURE`}
          request={{requestedProcedureCode}}
          callback={copyData}
          isFormDisabled={isDisabled}
        />
      </Grid.Column>
      <Grid.Column width={14} className='divFormFeild  border-bottom'>
        <DropDown
          id={`additionalProc-${id}`}
          label='Additional Procedure'
          disabled={isFormDisabled}
          className='field-bg dropdown100 addInfoCode'
          boxNumber='1/11'
          labelClass='text-none'
          isLabel={true}
          data={additionalProcedureList}
          value={requestedProcedureCode}
          clearable
          onChange={(value) => {
            updateItem(id,{requestedProcedureCode:value?.trim()})
            saveItem({id,requestedProcedureCode:value})
          }}
        />
          </Grid.Column>
      <Grid.Column width={1} className="icon-delete-add-info">
        <DeleteIcon onClick={() =>deleteItem(id)} disabled={isFormDisabled} />
    </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(AdditionalProcedureForm)


